import React from 'react';
import { useSelector } from 'react-redux';
import styles from './transaction.module.css';

const SubscriptionHistory = () => {
  const subscriptions = useSelector(
    (state) => state.auth.user.account.subscriptions
  );
  return (
    <div className={styles.listWrapper}>
      {subscriptions.map((sub, key) => {
        return (
          <div className={styles.itemWrapper} key={key}>
            <div className={styles.detail}>
              <h3 className={styles.title}>{sub.packageGroup.name}</h3>
              <span className={styles.subtitle}>{sub.packageName}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SubscriptionHistory;
